var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "settings-engineers-users-hkland-data" } }, [
    _c("table", { staticClass: "setting-table user-table" }, [
      _c("thead", [
        _c("th", { staticClass: "user-name" }, [
          _vm._v(_vm._s(_vm.$t(_vm.defaultHeader.name))),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "user-status" }, [
          _vm._v(_vm._s(_vm.$t(_vm.status.name))),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "last-login" }, [
          _vm._v(_vm._s(_vm.$t(_vm.lastLogin.name))),
        ]),
      ]),
      _vm._v(" "),
      _c("tbody", { staticClass: "setting-tbody" }, [
        _c("tr", [
          _c("td", { staticClass: "user-name" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.defaultHeader.filter,
                  expression: "defaultHeader.filter",
                },
              ],
              staticClass: "setting-users-filter-search",
              attrs: {
                type: "text",
                id: "settings-engineers-users-hkland-user-filter",
              },
              domProps: { value: _vm.defaultHeader.filter },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.defaultHeader, "filter", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "td",
            { staticClass: "user-status settings-filter" },
            [
              _c("HKLSelect", {
                staticClass: "hkld-user-status-filter",
                attrs: {
                  value: _vm.status.filter,
                  "settings-filter-row": "",
                  options: _vm.statusHklOptions,
                  showSearch: false,
                  placeholder: "",
                },
                on: {
                  change: function (val) {
                    _vm.status.filter = val
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("td", {
            staticClass: "last-login",
            attrs: { id: "settings-engineers-users-hkland-user-last-login" },
          }),
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "list" }, [
          _c(
            "tbody",
            [
              _vm._l(_vm.filteredUsers, function (user, index) {
                return [
                  user.id !== _vm.systemUserId
                    ? _c("tr", { key: user.id }, [
                        _c("td", { staticClass: "user-name" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                id:
                                  "settings-engineers-users-hkland-user-" +
                                  index,
                              },
                            },
                            [_vm._v(_vm._s(_vm.userName(user)))]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "user-status" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                user.enabled
                                  ? _vm.$t("status.active")
                                  : _vm.$t("status.inactive")
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "last-login" }, [
                          _c("div", [
                            _vm._v(_vm._s(_vm.formatDate(user.lastLoginAt))),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }